// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.wombat",
    name: "Wombat",
    homepage: "https://wombat.app",
    image_id: "e675efa3-4ffc-4199-9c22-b9692baea900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/wombat-home-of-nft-gaming/id1474392110",
        android: "https://play.google.com/store/apps/details?id=io.getwombat.android",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "wombat-wc://",
        universal: null,
    },
    desktop: {
        native: "wombat://",
        universal: null,
    },
};
//# sourceMappingURL=index.js.map